{
  "error.cookie_needed.description": "お使いのブラウザーは、Cookie およびローカルストレージをブロックするように設定されています。\nExperience Cloud にアクセスするために、ブラウザー環境設定で Cookie を許可してください。",
  "error.cookie_needed.heading": "Cookie がブロックされています",
  "error.cookie_needed.refreshBtn": "更新",
  "error.not_found.description": "このページは使用できません。URL を確認するか、別のページにアクセスしてみてください。",
  "error.not_found.heading": "エラー 404：ページが見つかりません",
  "error.offline.description": "インターネット接続を確認し、ページを更新してください",
  "error.offline.heading": "インターネット接続なし",
  "error.rate_limit.description": "大量の処理が発生しています。ページをリロードするか、数分後にもう一度試してください。\nこのメッセージが引き続き表示される場合は、カスタマーケアにお問い合わせください。その際に、以下をお知らせください：\nEIM インスタンス ID {instanceId}",
  "error.rate_limit.heading": "エラー 429：レートが制限されています",
  "error.rate_limit.refreshBtn": "更新",
  "error.timeout.description": "このページを読み込めませんでした。ページを更新するか、別のページにアクセスしてみてください。\nこのメッセージが引き続き表示される場合は、カスタマーケアにお問い合わせください。その際に、以下をお知らせください：\nEIM インスタンス ID {instanceId}",
  "error.timeout.heading": "エラー 408：リクエストのタイムアウト",
  "error.timeout.refreshBtn": "更新",
  "error.unknown.description": "ページが正しく読み込まれませんでした。ログインを確認してから、もう一度やり直してください。\nこのメッセージが引き続き表示される場合は、カスタマーケアにお問い合わせください。その際に、以下をお知らせください：\nEIM インスタンス ID {instanceId}",
  "error.unknown.heading": "ページの読み込みに失敗しました",
  "error.unknown.refreshBtn": "更新"
}
